import { render } from "./BudgetCreate.vue?vue&type=template&id=c9aa1b0a&scoped=true"
import script from "./BudgetCreate.vue?vue&type=script&lang=js"
export * from "./BudgetCreate.vue?vue&type=script&lang=js"

import "./BudgetCreate.vue?vue&type=style&index=0&id=c9aa1b0a&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9aa1b0a"]])

export default __exports__